import { render, staticRenderFns } from "./CalendarSection.vue?vue&type=template&id=22dcef8d&scoped=true&"
import script from "./CalendarSection.vue?vue&type=script&lang=js&"
export * from "./CalendarSection.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSection.vue?vue&type=style&index=0&id=22dcef8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcef8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VImg,VSheet})
